<template>
  <div class="my_form">
    <el-form class="form" :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :span="8">
          <el-form-item label="证照编号:" prop="license_no">
            <el-input v-model="form.license_no"/>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="证照类型:" prop="license_type">
              <el-select v-model="form.license_type" filterable>
                  <el-option v-for="(item,key) in licenseType" :key="key" :label="item" :value="key" />
              </el-select>
            </el-form-item>
          </el-col>
        <el-col :span="8">
          <el-form-item label="证照名称:" prop="license_name">
            <el-input v-model="form.license_name"/>
          </el-form-item>
        </el-col>
        <el-col :span="6" class="action">
            <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>
            <el-button size="small" @click="resetForm">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <STable :columns="columns" :loadData="loadData" ref="table">
      <template #sn='{ $index }'>
        {{ $index + 1 }}
      </template>
      <template #status="record">
        {{licenseStatus[record.row.status]}}
      </template>
      <template #license_type="record">
        {{licenseType[record.row.license_type]}}
      </template>
      <template #staff_name="record">
        {{ filterName(record.row) }}
      </template>
      
      <template #action="record">
          <a href="javascript:;"  class="success" @click="handleOpenDetail(record.row)">详细信息</a>
          <a href="javascript:;" @click="handleBorrow(record.row)">借用</a>
      </template>
    </STable>
    <ItemMoudle :visible.sync='visible' :record='record' @submitForm='submitForm' />
    <BorrowMould :visible.sync='visibleBorrow' :record='record' @submitForm='submitForm'  />
  </div>
</template>

<script>
import { LicenseManagement } from '@/api/Licence'
import STable from '@/components/STable';
import { licenseType, licenseStatus} from '@/utils/data'
import ItemMoudle from './ItemMoudle.vue';
import BorrowMould from './BorrowMould.vue';

export default {
  components: {
    STable,
    ItemMoudle,
    BorrowMould
  },
  data () {
    return {
      form: {
        license_no: '',
        license_type: '',
        license_name: ''
      },
      columns: [
        {
          label: '序号',
          scopedSlots: 'sn',
          width: 100
        },
        {
          label: '单位员工',
          scopedSlots: 'staff_name',
          ellipsis: true,
          width: 200
        },
        {
          label: '证照类型',
          scopedSlots: 'license_type',
          ellipsis: true,
          width: 250
        },
        {
          label: '证照编号',
          prop: 'license_no',
          width: 300,
          ellipsis: true
        },
        {
          label: '证照名称',
          prop: 'license_name',
          width: 400,
          ellipsis: true
        },
        {
          label: '状态',
          scopedSlots: 'status',
          width: 150,
          ellipsis: true
        },
        {
          label: '操作',
          scopedSlots: 'action',
          width: 150,
          fixed: 'right',
          ellipsis: true
        }
      ],
      loadData: (pageParam) => {
        const arr = []
        for (var key in this.form) {
          if (this.form[key]) {
            arr.push({
              columnName: key,
              columnValue: this.form[key],
              filterType: 3,
              tableName: 'oa_form_staff_license'
            })
          }
        }
        return LicenseManagement.getList(this, { datasourceId: '1631157465292738560', filterDtoList: arr, pageParam }).then(rs => rs)
      },
      licenseType,
      licenseStatus,
      visible: false,
      record: {},
      peopleList: [], // 人员
      visibleBorrow: false
    }
  },
  created () {
    this.getPeople()
  },
  methods: {
    getPeople () {
      LicenseManagement.getPeopleList(this, {}).then(res => {
        this.peopleList = res.data.dataList
      })
    },
    handleOpenDetail (record) {
      this.record = record
      this.visible = true
    },
    handleBorrow (record) {
      this.record = record
      this.visibleBorrow = true
    },
    submitForm (flag = true) {
      if (this.$refs.table) this.$refs.table.refresh(flag)
    },
    resetForm () {
      this.form = {
        license_no: '',
        status: '',
        license_name: ''
      }
      this.submitForm()
    },
    filterName(record){
      const item = this.peopleList.find(item => item.userId * 1 == record.staff_name * 1)
      return item ? item.showName : ''
    },
  }
}
</script>
